import { UserPresenceSliceActions } from "./user-presence.slice";

export const { setUserPresence, setUserPresences } = UserPresenceSliceActions;
